export default "__VITE_ASSET__DxA$TRRO__"